import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { View, ViewStyle } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** A card of the report, titled or not; `trailing` sits beside the title. */
export const ReportSection = memo(
  ({
    title,
    trailing,
    style,
    children,
  }: {
    title?: string;
    trailing?: ReactNode;
    style?: ViewStyle;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={[
          {
            borderRadius: rpx(18),
            borderWidth: 1,
            borderColor: aiColors.border,
            backgroundColor: aiColors.card,
            padding: rpx(16),
            gap: rpx(12),
            shadowColor: '#0F172A',
            shadowOpacity: 0.04,
            shadowRadius: 4,
            shadowOffset: { width: 0, height: 1 },
            elevation: 1,
          },
          style,
        ]}
      >
        {title ? (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: rpx(8),
            }}
          >
            <Typography.Text size={rpx(14)} bold color={aiColors.foreground}>
              {title}
            </Typography.Text>
            {trailing}
          </View>
        ) : null}
        {children}
      </View>
    );
  },
);
